// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_CreateResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/orders/create
 *
 * Returns the id of the newly created order.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_CreateResponseDados {
order_id: number
}

export type Orders_CreateResponse = ApiResponse<Orders_CreateResponseDados>;

registerResponseContract('Orders_CreateResponse', {
  order_id: { type: 'number',  required: true },
})
